import moment from 'moment';

export class GuidedSearchHelper {
  /**
   * Returns an object that is formatted to be sent
   * @returns {string}
   * @param data
   */
  static formatDataStore(data) {
    const SEPARATOR = '/$$/';
    const dataToSend = {};
    const monthNumber = moment(data.installationMonth.month, 'MMMM').format('MM');
    dataToSend.budget = data.budget.isUnknown ? null : parseInt(data.budget.price, 10);
    dataToSend.teamSize = data.capacity.min;
    dataToSend.teamSizeMax = data.capacity.max;
    dataToSend.duration = data.duration.value;
    dataToSend.installationMonth = data.installationMonth === -1 ? null : `01-${monthNumber}-${data.installationMonth.year}`;
    const loc = data.location;
    if (loc.defaultLocationPostalCode === null) {
      dataToSend.location = `${loc.locationPostalCodeInput}${SEPARATOR}${loc.locationTownInput}${SEPARATOR}`;
    }
    if (loc.defaultLocationPostalCode !== null) {
      dataToSend.location = `${loc.defaultLocationPostalCode}${SEPARATOR}${loc.locationChoice.name}${SEPARATOR}${loc.selectedTagsCity ? loc.selectedTagsCity.join(', ') : ''}`;
    }
    dataToSend.organization = {
      name: data.organization,
    };
    dataToSend.fullName = data.user.fullName;
    dataToSend.phoneNumber = data.user.phoneNumber;
    dataToSend.email = data.user.email;

    return dataToSend;
  }
}
